import React, { Component } from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import Loadable from 'react-loadable'
import { connect } from "react-redux";

import { configurePushNotifications } from '../actions'
// import SideBar from "../containers/SideBar"
import OnaModal from '../components/OnaModal'
import PrivateRoute from '../navigation/PrivateRoute'

function Loading(props) {
    if (props.pastDelay) {
        return <div />;
    } else {
        return null;
    }
}

const Dashboard = Loadable({
    loader: () => import('../containers/Dashboard/'),
    loading: Loading,
    delay: 300
})

const TaskDetailsView = Loadable({
    loader: () => import('../containers/TaskDetailsView/'),
    loading: Loading,
    delay: 300
})

const PostTaskView = Loadable({
    loader: () => import('../containers/PostTaskView'),
    loading: Loading,
    delay: 300
})

const LoginView = Loadable({
    loader: () => import('../containers/LoginView'),
    loading: Loading,
    delay: 300
})

const Help = Loadable({
    loader: () => import('../containers/Help'),
    loading: Loading,
    delay: 300
})

const ChangePasswordView = Loadable({
    loader: () => import('../containers/ChangePasswordView'),
    loading: Loading,
    delay: 300
})

const SendFPConfirmationView = Loadable({
    loader: () => import('../containers/SendFPConfirmationView'),
    loading: Loading,
    delay: 300
})

const HistoryView = Loadable({
    loader: () => import('../containers/HistoryView'),
    loading: Loading,
    delay: 300
})

const NotificationsView = Loadable({
    loader: () => import('../containers/NotificationsView'),
    loading: Loading,
    delay: 300
})

const ProfileView = Loadable({
    loader: () => import('../containers/ProfileView'),
    loading: Loading,
    delay: 300
})

const Analytics = Loadable({
    loader: () => import('../containers/Analytics'),
    loading: Loading,
    delay: 300
})

const SideBar = Loadable(
    {
        loader: () => import('../containers/SideBar'),
        loading: Loading,
        delay: 300
    }
)

const Vehicle = Loadable(
    {
        loader: () => import('../containers/Vehicle'),
        loading: Loading,
        delay: 300
    }
)

const VehicleDetails = Loadable(
    {
        loader: () => import('../containers/VehicleDetails'),
        loading: Loading,
        delay: 300
    }
)
const HomeView = Loadable(
    {
        loader: () => import('../containers/HomeView'),
        loading: Loading,
        delay: 300
    }
)

class NavRouter extends Component {

    componentDidMount() {
        if (this.props.isLoggedIn) {
            this.props.configurePushNotifications()
        }
    }

    wrapWithAppheader = (View, props) => {
        const view = () => {
            return (
                <View {...props} />
            );
        }
        return (
            <SideBar {...props} mainContent={view} />
        );
    }

    render() {
        return (
            <BrowserRouter>
                <OnaModal />
                <Switch>
                    <Route path={'/login'} component={LoginView} />
                    <Route exact path="/changePassword" component={ChangePasswordView} />
                    <Route exact path="/verifyForgotPasswordEmail" component={SendFPConfirmationView} />
                    <Route exact path="/" component={HomeView} />

                    <PrivateRoute exact path="/post-task" component={(props) => this.wrapWithAppheader(PostTaskView, props)} authed={this.props.isLoggedIn} />
                    <PrivateRoute path="/tasks/:taskId" component={(props) => this.wrapWithAppheader(TaskDetailsView, props)} authed={this.props.isLoggedIn} />
                    <PrivateRoute exact path="/history" component={(props) => this.wrapWithAppheader(HistoryView, props)} authed={this.props.isLoggedIn} />
                    <PrivateRoute exact path="/help" component={(props) => this.wrapWithAppheader(Help, props)} authed={this.props.isLoggedIn} />
                    <PrivateRoute exact path="/changePassword" component={(props) => this.wrapWithAppheader(ChangePasswordView, props)} authed={this.props.isLoggedIn} />
                    <PrivateRoute exact path="/notifications" component={(props) => this.wrapWithAppheader(NotificationsView, props)} authed={this.props.isLoggedIn} />
                    <PrivateRoute exact path="/profile" component={(props) => this.wrapWithAppheader(ProfileView, props)} authed={this.props.isLoggedIn} />
                    <PrivateRoute exact path="/analytics" component={(props) => this.wrapWithAppheader(Analytics, props)} authed={this.props.isLoggedIn} />
                    {/* <PrivateRoute exact path="/asset" component={(props) => this.wrapWithAppheader(Vehicle, props)} authed={this.props.isLoggedIn} />
                    <PrivateRoute exact path="/asset/:vehicleId" component={(props) => this.wrapWithAppheader(VehicleDetails, props)} authed={this.props.isLoggedIn} /> */}

                    <PrivateRoute exact={false} path="/dashboard" component={(props) => this.wrapWithAppheader(Dashboard, props)} authed={this.props.isLoggedIn} />

                </Switch>
            </BrowserRouter >
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.user.isLoggedIn,
    };
};

export default connect(mapStateToProps, { configurePushNotifications })(NavRouter);
